var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 67,
    viewBox: "0 0 57 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3158 56.0527C46.3158 57.7095 44.9727 59.0527 43.3158 59.0527H3C1.34315 59.0527 0 57.7095 0 56.0527V3C0 1.34315 1.34315 0 3 0H35.8948L40.5263 4.63158L46.3158 10.4211V56.0527Z",
    fill: "#6B8299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3156 10.4211L35.8945 0V9.42106C35.8945 9.97334 36.3422 10.4211 36.8945 10.4211H46.3156Z",
    fill: "#8CA2B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26367 16.2109H33.5795",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26367 25.4746H29.1676",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26367 34.7373H21.4272",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26367 44H17.0447",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6838,
    cy: 52.1057,
    r: 13.8947,
    fill: "#CD2D27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4479 54.2016C34.3233 53.6436 34.2579 53.0658 34.2578 52.4762C34.2578 52.2437 34.2677 52.0144 34.2879 51.7875C34.5405 48.8951 36.357 46.3729 39.021 45.2166C42.2292 43.8248 45.9711 44.704 48.2235 47.3792C48.3838 47.5696 48.5339 47.7659 48.6737 47.9673M49.9033 50.7967C50.3425 52.8232 49.9801 54.996 48.7863 56.8154C46.8678 59.7395 43.2573 61.0572 39.9062 60.0562C38.0717 59.5084 36.5533 58.3371 35.5546 56.8154",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4473 53.1611L34.4967 54.6879L36.0235 52.6384",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8984 52.1367L50.0913 50.3296L48.2842 52.1367",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyFailed);
export default __webpack_public_path__ + "static/media/verify-failed.f9d16e31e2fcf541e4c42e8f62769e1e.svg";
export { ForwardRef as ReactComponent };